<template>
  <div id="cover" class="col-12">
    <mdb-card
      class="card-image flex-center"
      style="background-image: url(https://mdbootstrap.com/img/Photos/Others/gradient1.jpg)"
    >
      <div class="text-white text-center py-5 px-4 my-5">
        <div class="align-self-center">
          <h2 class="card-title h1-responsive pt-5 mb-3 font-bold">
            <strong>Imprenta Las Américas</strong>
          </h2>
          <h5 class="mx-5 mb-5">
            Impresos y Mucho Más... 40+ Años de Experiencia
          </h5>
        </div>
        <mdb-btn @click="estimate" outline="white" size="md" icon="clone"
          >Estimados Gratis</mdb-btn
        >
      </div>
    </mdb-card>
  </div>
</template>

<script>
import store from "../store/index";
import { mdbCard, mdbBtn } from "mdbvue";
export default {
  name: "JumbotronPage",
  components: {
    mdbCard,
    mdbBtn,
  },
  methods: {
    estimate() {
      if (store.state.loggedIn === false) {
        this.$notify.info({
          message: "Debe estar reegistrado para el estimado",
          position: "top right",
          timeOut: 3000,
        });
      }
      store.state.loggedIn;
    },
  },
};
</script>

<style lang="css">
.card-image {
  height: 600px;
}

#cover {
  padding: 0px;
}
</style>
